import { render } from "./HelpComponent.vue?vue&type=template&id=5511d44a&scoped=true"
import script from "./HelpComponent.vue?vue&type=script&lang=js"
export * from "./HelpComponent.vue?vue&type=script&lang=js"

import "./HelpComponent.vue?vue&type=style&index=0&id=5511d44a&scoped=true&lang=css"

import exportComponent from "../../../../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5511d44a"]])

export default __exports__